import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

import { RouteContext } from 'lib/ContextTypes';

import styles from './styles.module.scss';

function Navbar(props) {
  let {
    html,
  } = props;

  const {
    active,
    hasGlobalInsert,
    hasLocalInsert,
    useSmallNav,
    shortcuts,
    showGlobal,
    theme,
    showPolitics,
  } = props;

  const {
    publicRuntimeConfig: {
      ENABLE_RELATIVE_LINKS,
    },
  } = getConfig();

  // Remove production hostname from links in navbar html
  if (ENABLE_RELATIVE_LINKS) {
    const route = React.useContext(RouteContext);
    // Production hostname
    const prodHostname = `https://www.${route.domain}`;
    // Find links to root hostname - non capture hostname without trailing slash
    const regexRoot = new RegExp(`(?:${prodHostname})(?!/)`, 'g');
    // All other links with hostname:
    const regexSub = new RegExp(`${prodHostname}`, 'g');

    // Replace links to root first
    html = html.replace(regexRoot, '/');
    // Then replace hostname on sub links
    html = html.replace(regexSub, '');
  }

  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    if (window.scrollY) {
      setIsScrolled(true);
    }
  }, []);

  return (
    <nav
      className={classNames(
        'hfsh init',
        {
          active,
          scrolled: isScrolled,
          'has-global-insert': hasGlobalInsert,
          'has-local-insert': hasLocalInsert,
          small: useSmallNav,
          'show-global': showGlobal,
          'hide-global': !showGlobal,
          'show-shortcuts': shortcuts,
          politics: showPolitics,
          [theme]: theme,
        },
        [styles.override],
      )}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
}

Navbar.propTypes = {
  active: PropTypes.bool.isRequired,
  hasGlobalInsert: PropTypes.bool.isRequired,
  hasLocalInsert: PropTypes.bool.isRequired,
  useSmallNav: PropTypes.bool.isRequired,
  html: PropTypes.string.isRequired,
  shortcuts: PropTypes.bool.isRequired,
  showGlobal: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
  showPolitics: PropTypes.bool,
};

Navbar.defaultProps = {
  showPolitics: false,
};

const mapStateToProps = ({ navbar }) => ({
  active: navbar.active,
  hasGlobalInsert: navbar.hasGlobalInsert,
  hasLocalInsert: navbar.hasLocalInsert,
  shortcuts: navbar.shortcutsVisible,
  theme: navbar.theme,
});

export const HeaderNavbar = connect(mapStateToProps)(
  Navbar,
);
